<template>
    <div
        class="grid-item grid-item-half grid-item-break-half">
        <p class="stack-s">Format</p>
        <v-radio
            v-for="(formatOption, index) in formats"
            group="format"
            :class="{'stack-m': formats.length - 1 !== index}"
            :label="formatOption.label"
            :value="formatOption.value"
            :key="formatOption.value"
            :model="format"
            :validate="validate"
            @update="updateFormat"
        />
    </div>
</template>

<script>
    import {DataExportModel} from '@/common/models/data-export-model';
    import {vRadio} from '@/components/form';

    export default {
        name: 'format-form',
        components: {
            vRadio,
        },
        props: {
            validate: {
                type: Object,
                required: true,
            },
            format: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                formats: Object.values(DataExportModel.Formats)
                    .map(value => ({
                        value,
                        label: value.toUpperCase(),
                    })),
            };
        },
        methods: {
            updateFormat(format) {
                this.$emit('update', format);
            },
        },
    };
</script>
